module.exports = __webpack_public_path__ + "img/dino.2a5c7b8b.webp";